import { useEffect } from 'react';
import { useAppContext } from '../../../AppContext';
import { useChatContext } from '../../../contexts/ChatContext';
import { useTelephonyContext } from '../../../contexts/TelephonyContext';
import { Page } from '../../../models/Page';

interface UseContactViewingProps {
  onViewContact?: (contactId: string | undefined) => void;
}

export function useContactViewing({ onViewContact }: UseContactViewingProps): void {
  const { activePage } = useAppContext();
  const { selectedChat, setSelectedChat } = useChatContext();
  const { voiceContact } = useTelephonyContext();

  useEffect(() => {
    if (activePage !== Page.CHAT) {
      setSelectedChat(null);
    }
  }, [activePage, setSelectedChat]);

  useEffect(() => {
    if (!selectedChat || !onViewContact) {
      return;
    }
    onViewContact(selectedChat);
  }, [selectedChat, onViewContact]);

  useEffect(() => {
    if (!voiceContact || !onViewContact) {
      return;
    }
    onViewContact(voiceContact.contactId);
  }, [voiceContact, onViewContact]);
}
